<template>

  <card shadow class="card-profile b-2" style="width: 100%; color: black;" no-body>
    <div class="px-4">
      <!-- Search Bar -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h1 class="display-3 mt-3">Купон жагсаалт</h1>
        <div class="d-flex align-items-center">
          <button class="btn btn-success" @click="openEditModal">Үүсгэх</button>
        </div>
      </div>

      <table class="table" v-if="CouponList.length">
        <thead>
          <tr>
            <th>ID</th>
            <th>Купон код</th>
            <th>Хямдруулах хувь</th>
            <th>Төлөв</th>
            <th class="text-right">Үйлдлүүд</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="coupon in CouponList" :key="coupon.id">
            <td>{{ coupon.id }}</td>
            <td class="text-center" style="display: flex; flex-direction: column">
              <span class="display-4 mb-0" style="text-align: left">
                {{ coupon.code }}
              </span>
            </td>
            <td>
              <span> {{ coupon.percent }}% </span>
            </td>
            <td>
              <span> {{ coupon.used_user_id ? "ашигласан" : "ашиглаагүй" }} </span>
            </td>
            <td class="td-actions text-right">
              <button type="button" class="btn btn-info btn-icon btn-sm" @click="openImageModal(coupon)"
                title="Купоныг харах">
                <i class="fa fa-image pt-1"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <Modal :show.sync="showModal" class="modalOverlay">
      <div class="modal-header">
        <h3>Купон нэмэx</h3>
      </div>

      <form @submit.prevent="handleSubmit" class="modalForm">
        <div class="form-group">
          <label>Хямдруулах хувь</label>
          <input v-model="couponData.percent" class="form-control" type="text" required />
        </div>

        <div class="form-group">
          <label>Үүсгэх тоо</label>
          <input v-model="couponData.count" class="form-control" type="text" required />
        </div>

        <div class="modal-footer">
          <base-button type="link" class="cancelButton" @click="closeModal">
            буцах
          </base-button>
          <base-button @click="handleSubmit" type="primary" class="saveButton">хадгалах</base-button>
        </div>
      </form>
    </Modal>
    <Modal :show.sync="showImageModal" class="modalOverlay">
  <div class="modal-header">
    <h3>Купоны мэдээлэл</h3>
  </div>

  <div class="modal-body" v-if="selectedCoupon">
    <!-- Coupon Visual Box -->
    <div
      ref="couponCard"
      class="coupon-card text-center p-4"
      style="
        background: #f8f8f8;
        border: 2px dashed #999;
        border-radius: 12px;
        max-width: 400px;
        margin: 0 auto;
        color: #333;
        font-family: Arial, sans-serif;
      "
    >
      <!-- Top: Website -->
      <div style="font-size: 18px; font-weight: bold; margin-bottom: 10px;">
        {{ websiteName }}
      </div>

      <!-- Middle: Discount Percent -->
      <div style="font-size: 48px; font-weight: bold; margin: 20px 0;">
        {{ selectedCoupon.percent }}%
      </div>

      <!-- Bottom: Coupon Code -->
      <div style="font-size: 20px; font-weight: bold;">
        Купон код: {{ selectedCoupon.code }}
      </div>
    </div>

    <!-- Button to generate image -->
    <button class="btn btn-primary mt-3" @click="generateImage">
      Зураг болгох
    </button>
  </div>

  <div class="modal-footer">
    <base-button type="link" class="cancelButton" @click="closeImageModal">
      хаах
    </base-button>
  </div>
</Modal>
  </card>


</template>

<script>
import axios from "axios";
import Modal from "@/components/Modal.vue";
import html2canvas from "html2canvas";

export default {
  name: "Coupons",
  data() {
    return {
      CouponList: [],
      showModal: false,
      couponData: {
        count: 0,
        percent: 0,
      },
      searchQuery: "",
      sortDirection: "asc",
      selectedCoupon: null,
      showImageModal: false,
      websiteName: window.location.hostname,
    };
  },
  created() {
    this.fetchCouponList();
  },
  components: {
    Modal,
  },
  methods: {
    fetchCouponList() {
      axios
        .get("/coupons")
        .then((response) => {
          this.CouponList = response.data;
        })
        .catch((error) => {
          console.error("Error fetching coupons list:", error);
        });
    },

    openEditModal() {
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
    },
    openImageModal(coupon) {
      this.selectedCoupon = coupon;
      this.showImageModal = true;
    },
    closeImageModal() {
      this.showImageModal = false;
    },
    generateImage() {
      const element = this.$refs.couponCard;
      html2canvas(element).then((canvas) => {
        const link = document.createElement("a");
        link.download = `coupon-${this.selectedCoupon.id}.png`;
        link.href = canvas.toDataURL("image/png");
        link.click();
      });
    },
    
    handleSubmit() {

      axios
        .post('/coupons', this.couponData)
        .then(() => {
          this.fetchCouponList();
          this.closeModal();
        })
        .catch((error) => {
          console.error("Submission error:", error);
        });

    },
  },
};
</script>

<style scoped>
.btn-link {
  text-decoration: none;
  color: inherit;
  padding: 0;
}

.btn-link:hover {
  text-decoration: none;
  color: inherit;
}
</style>